import moment from 'moment'

const defaultStates = {
  si: 'Exitoso',
  no: 'Error',
}

export const columns = () => [
  {
    name: 'Tipo de Documento',
    selector: (row) => row.nombreTipoDocumento,
  },
  {
    name: 'Nombre Receptor',
    selector: (row) => row.nombreReceptor,
  },
  {
    name: 'Fecha de Envío',
    selector: (row) => moment(row.fechaEnvio).format('YYYY-MM-DD'),
  },
  {
    name: 'Tipo de Documento de Identidad',
    selector: (row) => row.tipoDocumentoIdentidad,
  },
  {
    name: 'Número de Documento de Identidad',
    selector: (row) => row.numeroDocumentoIdentidad,
  },
  {
    name: 'NRC',
    selector: (row) => row.nrc,
  },
  {
    name: 'Código de Generación',
    selector: (row) => row.codigoGeneracion,
  },
  {
    name: 'Número de Control',
    selector: (row) => row.numeroControl,
  },
  {
    name: 'Estado',
    selector: (row) =>
      defaultStates[row.estadoExitoso?.toLowerCase()] ?? row.estadoExitoso,
  },
  {
    name: 'IVA',
    selector: (row) => row.iva,
  },
  {
    name: 'Venta Grabada',
    selector: (row) => row.ventaGrabada,
  },
  {
    name: 'Venta No Grabada',
    selector: (row) => row.ventaNoGrabada,
  },
  {
    name: 'Total',
    selector: (row) => row.total,
  },
]
